import { render, staticRenderFns } from "./sftp-form.vue?vue&type=template&id=53bd6dd4"
import script from "./sftp-form.vue?vue&type=script&lang=js"
export * from "./sftp-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports